import type { HermesGuardFn } from '@/router/guards/types'
import { refreshFeatureFlagsForBrand } from '@/utils/refreshFeatureFlagsForBrand'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const LEGACY_ORDERS_ROUTE = 'brand.orders'
const LEGACY_ORDERS_DETAIL_ROUTE = 'brand.orders.detail'
const HESTIA_ORDERS_ROUTE = 'brand.apps.orders'
const HESTIA_ORDERS_ROUTE_NAMES = new Set([
  HESTIA_ORDERS_ROUTE,
  LEGACY_ORDERS_DETAIL_ROUTE,
  LEGACY_ORDERS_ROUTE,
])

export const HESTIA_ORDERS_FEATURE_FLAG = 'hermes.hestiaOrders'

const getRouteParamString = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    return getRouteParamString(value[0])
  }

  return typeof value === 'string' && value.length > 0 ? value : undefined
}

export const checkHestiaOrdersFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !HESTIA_ORDERS_ROUTE_NAMES.has(to.name)) {
    return undefined
  }

  const featureFlags = useFeatureFlags()
  const brandId = getRouteParamString(to.params.brandId)
  await refreshFeatureFlagsForBrand(brandId)
  const hestiaOrdersEnabled = featureFlags.isEnabled(HESTIA_ORDERS_FEATURE_FLAG)

  if (to.name === HESTIA_ORDERS_ROUTE && !hestiaOrdersEnabled) {
    return {
      name: LEGACY_ORDERS_ROUTE,
      params: { brandId: to.params.brandId },
    }
  }

  if (
    hestiaOrdersEnabled &&
    (to.name === LEGACY_ORDERS_ROUTE || to.name === LEGACY_ORDERS_DETAIL_ROUTE)
  ) {
    const query = { ...to.query }
    const orderId = getRouteParamString(to.params.orderId)

    if (orderId) {
      query.orderId = orderId
    }

    return {
      name: HESTIA_ORDERS_ROUTE,
      params: { brandId: to.params.brandId },
      query,
    }
  }

  return undefined
}
